import {lazy} from 'react';

export const EventTeaserLazy = lazy(() => import(/* webpackChunkName: "eventTeaser" */ '.'));
